var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_12590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3938 0H1.8956C1.00949 0 0.292969 0.699563 0.292969 1.56448V20.1389C0.292969 21.0039 1.00949 21.7077 1.8956 21.7077H20.3938C21.2799 21.7077 22.0006 21.0039 22.0006 20.1432V1.56448C22.0006 0.699563 21.2799 0 20.3938 0ZM6.73319 18.4981H3.51096V8.13613H6.73319V18.4981ZM5.12208 6.72429C4.08757 6.72429 3.25233 5.88905 3.25233 4.85879C3.25233 3.82852 4.08757 2.99328 5.12208 2.99328C6.15234 2.99328 6.98758 3.82852 6.98758 4.85879C6.98758 5.88481 6.15234 6.72429 5.12208 6.72429ZM18.7911 18.4981H15.5731V13.4613C15.5731 12.2614 15.5519 10.7139 13.8984 10.7139C12.2237 10.7139 11.9693 12.024 11.9693 13.3765V18.4981H8.75557V8.13613H11.8421V9.55222H11.8845C12.3127 8.73818 13.3642 7.87751 14.9287 7.87751C18.1891 7.87751 18.7911 10.0228 18.7911 12.8126V18.4981Z",
    fill: "#E2EEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_12590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7077,
    height: 21.7077,
    fill: "white",
    transform: "translate(0.292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8acea0aa56bff733bd0e4b2724df8c6a.svg";
export { ForwardRef as ReactComponent };